import React from "react";
import {InputLabel} from "@mui/material";
import {CustomStyleLabel} from "./Styles";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Label
 * @param String id: Identifier for the label (required)
 * @param String trans: Text for the label (required)
 * @param String bold: Font weight for label (optional)
 * @returns {JSX.Element}
 */

const CustomDescriptionLabel = ({labelId = "custom-label", trans, bold="bold",className='' }) => {
    return <>
        <InputLabel className={className} id={labelId} sx={CustomStyleLabel(bold)}>{trans}</InputLabel>
    </>
}

export default CustomDescriptionLabel
